export default __webpack_public_path__ + "static/media/2D_Barcode_Logo_JP.bc708711.svg";